import { useCallback, useRef, useState } from 'react';
import { useMount } from 'react-use';
export function useBrowserStoredState({ storageKey, initialState, storage = globalThis.localStorage ?? globalThis.sessionStorage, ssr = false, }) {
    const [state, _setState] = useState(() => {
        if (ssr)
            return initialState;
        const storedState = storage?.getItem?.(storageKey);
        return storedState ? JSON.parse(storedState) : initialState;
    });
    const setStateCalledRef = useRef(false);
    const setState = useCallback((newState) => {
        setStateCalledRef.current = true;
        _setState(prevState => {
            const nextState = typeof newState === 'function' ? newState(prevState) : newState;
            storage?.setItem(storageKey, JSON.stringify(nextState));
            return nextState;
        });
    }, [storage, storageKey]);
    useMount(() => {
        if (!ssr || setStateCalledRef.current === true)
            return;
        const storedState = storage?.getItem(storageKey);
        if (storedState) {
            setState(JSON.parse(storedState));
        }
    });
    return {
        state,
        setState,
    };
}
//# sourceMappingURL=useBrowserStoredState.js.map